import { FunctionComponent, useState } from 'react'
import { MenuButton } from '../common/MenuButton'
import { MoreVertRounded, UploadRounded } from '@mui/icons-material'
import { ChecklistUploadModal } from './ChecklistUploadModal'
import { UploadDocumentModal } from './UploadDocumentModal'
import { MenuItem, Typography, rucksack } from '@black-bear-energy/rucksack'

export const ChecklistMenu: FunctionComponent<ChecklistMenuProps> = (
  props: ChecklistMenuProps
) => {
  const { checklistName, documents } = props
  const [uploadModalOpen, setUploadModalOpen] = useState(false)

  return (
    <>
      <MenuButton
        icon={<MoreVertRounded />}
        align="right"
        menuSx={{
          '& .MuiMenuItem-root': {
            display: 'flex',
            padding: '6px 16px',
            alignItems: 'center',
            gap: '12px',
          },
        }}
        keepOpen={false}
      >
        <MenuItem
          onClick={() => {
            setUploadModalOpen(true)
          }}
        >
          <UploadRounded sx={{ color: rucksack.palette.action.active }} />
          <Typography sx={{ fontSize: '1rem' }}>
            {props.isCollectionUpload
              ? 'Upload New Document'
              : 'Checklist Upload'}
          </Typography>
        </MenuItem>
      </MenuButton>
      {props.isCollectionUpload ? (
        <UploadDocumentModal
          documentId={props.placeholderDocumentId}
          documentName={checklistName}
          open={uploadModalOpen}
          onClose={() => setUploadModalOpen(false)}
          hasExistingUpload={false}
          isDocumentCollection
        />
      ) : (
        <ChecklistUploadModal
          checklistName={checklistName}
          documents={documents}
          open={uploadModalOpen}
          onClose={() => setUploadModalOpen(false)}
        />
      )}
    </>
  )
}

interface ChecklistMenuCommonProps {
  checklistName: string
  documents: { id: number; name: string }[]
}

interface CollectionUploadProps {
  isCollectionUpload: true
  placeholderDocumentId: number
}

interface ChecklistUploadProps {
  isCollectionUpload: false
}

export type ChecklistMenuProps = ChecklistMenuCommonProps &
  (CollectionUploadProps | ChecklistUploadProps)
